export default "__VITE_ASSET__CqOvi8El__"